import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery} from '@yandex-delivery/utils'

import type {ClaimsCreateAcceptedParams, ClaimsCreateAcceptedRequest, SearchedSddClaim} from 'src/shared/types'

import {fetch} from '../fetch'

export function fetchCreateAccepted(
  body: ClaimsCreateAcceptedRequest,
  params: ClaimsCreateAcceptedParams & {
    country?: string
  },
): Promise<SearchedSddClaim> {
  return fetch<ClaimsCreateAcceptedRequest, SearchedSddClaim, SearchedSddClaim>({
    method: 'POST',
    url: addQuery(externalApiURL('phoenix/dcaa/cargo/v1/claims/create-accepted'), params),
    body,
  })
}
